import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import userService from "../services/userService";

const AuthRoute = (props) => {
	
	let [ authenticated, setAuthenticated ] = useState(null);
	
	useEffect(() => {
		if (userService.AccessToken() && userService.User()) {
			return setAuthenticated(true);
		}
		
		userService.authenticateAccessToken()
		.then((authenticated) => {
			if (!authenticated) {
				return setAuthenticated(false);
			}
			return setAuthenticated(true);
		})
		.catch((err) => {
			console.log(`Auth Error: ${err.message}`);
			return setAuthenticated(false);
		});
	}, []);
	
	return (
		<React.Fragment>
			{
			(authenticated !== null)?
				authenticated? props.children : <Navigate to={{pathname: '/login', state: {from: props.location}}}/>
				:
				<React.Fragment/>
			}
		</React.Fragment>
	);
};

export default AuthRoute;